import { View } from '@aws-amplify/ui-react';

export const Description = ( { desc }) => {

    return (
        <View>
            {desc}
        </View>
    )
}